import { render } from "./OrderEditPage.vue?vue&type=template&id=951c29b4"
import script from "./OrderEditPage.vue?vue&type=script&lang=js"
export * from "./OrderEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__